import { FileResponseData } from './file';

export class ObservacionServicio {

  Id: number;
  ID_SOLICITUD_SERVICIO: number;
  ID_USER: number;
  FECHA: string;
  TEXTO: string;
  INTERNO: boolean;
  NOMBRE_USUARIO: string;
  UserIsDocout: boolean;
  EsAprobacion: boolean;
  Ficheros: FileResponseData[];
  filesShowed: { name: string, guid: string, date: string }[];
  //🥑🥑 PROVEEDOR
  tieneProveedor: boolean;
  MOMBRE_PROVEEDOR: string;


  constructor() { }

  static toModel(json: string): ObservacionServicio {
    const data = JSON.parse(json);
    if (data === null) {
      return null;
    }
    const toReturn = new ObservacionServicio();
    toReturn.Id = data.Id;
    toReturn.ID_SOLICITUD_SERVICIO = data.ID_SOLICITUD_SERVICIO;
    toReturn.ID_USER = data.ID_USER;

    toReturn.FECHA = data.FECHA;
    toReturn.TEXTO = data.TEXTO;
    toReturn.INTERNO = data.INTERNO;

    toReturn.NOMBRE_USUARIO = data.NOMBRE_USUARIO;
    toReturn.UserIsDocout = data.UserIsDocout;
    toReturn.EsAprobacion = data.EsAprobacion;

    toReturn.Ficheros = data.Fichero.map(fichero => FileResponseData.toModel(JSON.stringify(fichero)));
    //🥑🥑 PROVEEDOR
    toReturn.tieneProveedor = data.tieneProveedor;
    toReturn.MOMBRE_PROVEEDOR = data.MOMBRE_PROVEEDOR;

    return toReturn;
  }
}
